import { useCallback, useMemo } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface ReceiptItemNoteItem {
  itemNoteId: number;
  itemNoteCode: string;
  itemNoteValue: string;
}

export interface ReceiptItemNotesObject {
  [id: string]: ReceiptItemNoteItem;
}

const useReceiptItemNotesApi = () => {
  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.get<ReceiptItemNoteItem[]>(api.getReceiptNotes);
      return res.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }, []);

  const { value } = useAsync(call, true, undefined, []);

  const receiptItemNotesObject = useMemo(
    () =>
      value.reduce<ReceiptItemNotesObject>((acc, item) => {
        acc[item.itemNoteId] = item;
        return acc;
      }, {}),
    [value]
  );

  const UnassignedItemNotes: ReceiptItemNoteItem = useMemo(
    () => value.find((item) => item.itemNoteValue === 'Unassigned'),
    [value]
  ) as ReceiptItemNoteItem;

  return {
    receiptItemNotes: value,
    receiptItemNotesObject,
    UnassignedItemNotes,
  };
};

export default useReceiptItemNotesApi;
